import { render, staticRenderFns } from "./InactiveLife.vue?vue&type=template&id=6d1b48be&"
import script from "./InactiveLife.vue?vue&type=script&lang=js&"
export * from "./InactiveLife.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports